export function getLocalUrl(path: string = '') {
    return `/profile/${path}`;
}
